import React from 'react';
import { NavLink, Outlet, Navigate, useNavigate } from 'react-router-dom';
import PageShell from '../PageShell';
import { useUserAuth } from '../../context/UserAuthContext';
import { useI18n } from '../../context/I18nContext';
import { LayoutDashboard, ShoppingBag, Heart, LogOut, User, Wallet, Download, FileText, Server, Shield } from 'lucide-react';

export default function AccountLayout() {
  const { user, ready, logout } = useUserAuth();
  const { tr } = useI18n();
  const nav = useNavigate();
  if (!ready) return <PageShell eyebrow="" title="Yükleniyor..." />;
  if (!user) return <Navigate to="/login?redirect=/account" replace />;

  const items = [
    { to: '/account', end: true, label: tr('account.overview', 'Genel Bakış'), icon: LayoutDashboard },
    { to: '/account/wallet', label: tr('account.wallet', 'Cüzdanım'), icon: Wallet },
    { to: '/account/orders', label: tr('account.orders', 'Siparişlerim'), icon: ShoppingBag },
    { to: '/account/downloads', label: tr('account.downloads', 'İndirmeler'), icon: Download },
    { to: '/account/services', label: tr('account.services', 'Hizmetlerim'), icon: Server },
    { to: '/account/wishlist', label: tr('account.wishlist', 'Favoriler'), icon: Heart },
    { to: '/account/profile', label: tr('account.profile', 'Profil'), icon: User },
    { to: '/account/billing', label: tr('account.billing', 'Fatura Bilgileri'), icon: FileText },
    { to: '/account/2fa', label: tr('account.security', 'Güvenlik (2FA)'), icon: Shield },
  ];

  return (
    <PageShell eyebrow={tr('account.my_account', 'HESABIM')} title={<><span className="text-white">{tr('account.welcome', 'Hoş geldin')}, </span><span className="gold-text">{user.name || user.email}</span></>}>
      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
          <div className="grid lg:grid-cols-[240px_1fr] gap-8">
            <aside className="rounded-2xl border border-white/8 bg-[#0d0d13] p-3 h-fit">
              {items.map((it) => (
                <NavLink key={it.to} to={it.to} end={it.end} className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm transition ${isActive ? 'bg-[#e4b44e]/15 text-[#f4d896]' : 'text-white/70 hover:text-white hover:bg-white/5'}`}>
                  <it.icon className="w-4 h-4" /> {it.label}
                </NavLink>
              ))}
              <button onClick={() => { logout(); nav('/'); }} className="w-full mt-2 flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm text-white/70 hover:text-red-400 hover:bg-red-500/10">
                <LogOut className="w-4 h-4" /> {tr('account.logout', 'Çıkış')}
              </button>
            </aside>
            <div><Outlet /></div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
